import React from "react";
import { Formatter } from "./Formatter";
import { ReactQueryResult } from "src/shared/components/ReactQueryResult";
import { useCountriesMap } from "src/shared/contacts/countries/useCountriesMap";
import { useGetCountryNames } from "src/shared/contacts/countries/useGetCountryNames";
import type { Country } from "src/shared/objects/Country";

export interface ICountryNameProps {
  country: Country;
  isCopyable?: boolean;
}

export const CountryName = ({ country, isCopyable }: ICountryNameProps) => {
  const getCountryNames = useGetCountryNames();
  return (
    <Formatter isCopyable={isCopyable}>{getCountryNames(country)}</Formatter>
  );
};

export interface CountryCodeNameProps {
  children?: string;
  isCopyable?: boolean;
}

export const CountryCodeName = ({
  children,
  isCopyable,
}: CountryCodeNameProps) => {
  const countriesResult = useCountriesMap({ enabled: Boolean(children) });
  if (!children) {
    return <Formatter>{null}</Formatter>;
  }
  return (
    <ReactQueryResult {...countriesResult}>
      {(countries) => {
        const country = countries[children];
        if (!country) {
          return <Formatter isCopyable={isCopyable}>{children}</Formatter>;
        }
        return <CountryName country={country} isCopyable={isCopyable} />;
      }}
    </ReactQueryResult>
  );
};
